import { el, mount, unmount } from 'redom';

import application from 'application';

import externalEventCodes from 'event-system/codes/external';

import {
  findIndexByPropertyValue,
  getPropertyValues,
  filterByPropertyPartialValue
} from 'utilities/collection';

import { removeElementFromCollection } from '../utilities';
import EventRegistrationsFilter from './filter';
import EventRegistrationsList from './list';

class EventRegistrations {

  constructor(event, registrations) {

    this.nameFilterValue = '';

    this.postId = event.postId;
    this.eventOwnerId = event.ownerId;

    this.registrations = registrations;
    this.guests = [];
    this.filteredGuests = [];

    this.containerLabelViewEl = el('label.event-guests-list-container-label', 'Guests List');

    this.eventRegistrationsFilter = new EventRegistrationsFilter(this.handleNameFilterChange.bind(this));
    this.eventRegistrationsList = new EventRegistrationsList();

    this.eventGuestsListViewEl = el('div.event-guest-list-wrapper', [this.containerLabelViewEl, this.eventRegistrationsFilter, this.eventRegistrationsList]);

    this.el = el('div.event-guests-list-container', this.eventGuestsListViewEl);

  }

  onmount() {

    this.registerRegistrationCreatedEvent();

  }

  onunmount() {

    application.eventSystem.internal.offAllOn(this);

  }

  registerRegistrationCreatedEvent() {

    const postId = this.postId;

    application.eventSystem.internal.eventFor(this, `${postId}:${externalEventCodes.STARTUP_EVENT_REGISTRATION_CREATED}`, this.addEventRegistration.bind(this));
    application.eventSystem.internal.eventFor(this, `${postId}:${externalEventCodes.STARTUP_EVENT_REGISTRATION_DELETED}`, this.removeEventRegistration.bind(this));
    application.eventSystem.internal.eventFor(this, externalEventCodes.STARTUP_USER_FULL_NAME_GENERATED, this.handleUserFullNameUpdated.bind(this));

  }

  initialize() {

    this.loadGuests();

  }

  async loadGuests() {

    this.mountSpinner();

    const userIds = getPropertyValues(this.registrations, 'userId');

    this.guests = await application.usersStore.getUsersByIds(userIds);

    this.applyNameFilter();

    this.unmountSpinner();

  }

  async addEventRegistration(data) {

    const registration = data.registration;
    const user = await application.usersStore.getUserById(registration.userId);

    this.registrations.push(registration);
    this.guests.push(user);

    this.applyNameFilter();

  }

  removeEventRegistration(data) {

    this.guests = removeElementFromCollection(this.guests, data.userId);

    this.applyNameFilter();

  }

  async handleUserFullNameUpdated(userProfile) {

    const userIndex = findIndexByPropertyValue(this.registrations, '_id', userProfile);

    if (userIndex === -1) {
      return;
    }

    this.registrations[userIndex] = {
      ...this.registrations[userIndex],
      ...userProfile
    };

    this.applyNameFilter();

  }

  mountSpinner() {

    this.spinner = el('ht-spinner');

    mount(this.el, this.spinner);

  }

  unmountSpinner() {

    unmount(this.el, this.spinner);

  }

  applyNameFilter() {

    this.filteredGuests = filterByPropertyPartialValue(this.guests, 'fullName', this.nameFilterValue);

    this.eventRegistrationsList.update(this.filteredGuests, this.eventOwnerId);

  }

  handleNameFilterChange(name) {

    this.nameFilterValue = name;

    this.applyNameFilter();

  }

}

export default EventRegistrations;